module.exports = __webpack_public_path__ + "img/tab-default.eeb58146.jpg";